import { MOBILE_BREAKPOINT } from '$lib/components/constants';
import { PREVIEW_CONTAINER_ID, PREVIEW_MODE } from '$lib/global/constants';

import { browser } from '$app/environment';

import { writable, type Readable } from 'svelte/store';

const createIsMobileStore = (): Readable<boolean> => {
    const { subscribe, set } = writable<boolean>(false);

    if (!browser) {
        return { subscribe };
    }

    const updateIsMobile = () => {
        if (PREVIEW_MODE) {
            const container = document.getElementById(PREVIEW_CONTAINER_ID);
            const width = container?.clientWidth || 0;
            set(width < MOBILE_BREAKPOINT);
        } else {
            set(window.innerWidth < MOBILE_BREAKPOINT);
        }
    };

    updateIsMobile();

    if (PREVIEW_MODE) {
        const observer = new ResizeObserver(updateIsMobile);
        const container = document.getElementById(PREVIEW_CONTAINER_ID);

        if (container) {
            observer.observe(container);
        }
    } else {
        window.addEventListener('resize', updateIsMobile, { passive: true });
    }

    return { subscribe };
};

export const isMobile = createIsMobileStore();
